import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { showCredits } from '~app/actions/credits';
import { showGrid, showBorders } from '~app/actions/vector';
import { showHighRes } from '~app/actions/layers';

import CellDivider from './CellDivider';
import SettingsNavCell from './SettingsNavCell';
import SettingsToggleCell from './SettingsToggleCell';

const SettingsMenu = ({
  gridOn,
  bordersOn,
  highResOn,
  showGrid,
  showBorders,
  showHighRes,
  showCredits,
  onClose}) => (

  <div className="SettingsMenu">
    <SettingsToggleCell
      title="Gridlines:"
      enabled={gridOn}
      onClick={() => showGrid(!gridOn)}
    />
    <CellDivider />

    <SettingsToggleCell
      title="Political Boundaries:"
      enabled={bordersOn}
      onClick={() => showBorders(!bordersOn)}
    />
    <CellDivider />

    <SettingsNavCell
      title="More Information"
      onClick={() => {
        onClose();
        showCredits();
      }}
    />
    </div>
);

SettingsMenu.propTypes = {
  gridOn: PropTypes.bool.isRequired,
  bordersOn: PropTypes.bool.isRequired,
  highResOn: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  gridOn: state.vector.gridVisible,
  bordersOn: state.vector.bordersVisible,
  highResOn: state.layer.highResEnabled,
});

const mapDispatchToProps = {
  showGrid,
  showBorders,
  showHighRes,
  showCredits,
};

export { SettingsMenu };
export default connect(mapStateToProps, mapDispatchToProps)(SettingsMenu);



// WEBPACK FOOTER //
// ./src/components/SettingsMenu.js